export default __webpack_public_path__ + "static/media/medical-plan.7cc51c6c.svg";